import axios, {AxiosError} from "axios";
import { API_URL } from "../constant";
import { FetchHistoryResult} from "../constant";
  
export async function FectchFilingHistory(licenseNumber: string): Promise<FetchHistoryResult> {

    try {
        const token = localStorage.getItem("token")
        const data ={licenseNumber: licenseNumber}

        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
          };
      
        const response = await axios.post(
          `${API_URL}api/filing_history/getFilingHistory`,
          data,
          config
        );
    
        if (response.status === 200)
        {
            console.log(`Fetch filing history success, ${response.data.length}`);
            return { success: true, filing: response.data };
        }
        else if (response.status === 500)
        {
            return { success: false, errorMsg: "Internal Server Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}